export const filtrarReservas = ({reservas, estados = []}) => {

    let arrSoloOcupadas = []
    for (let i = 0; i < reservas.length; i++) {
        let reserva = reservas[i]
        if (estados.findIndex((e) => reserva.estado === e) === -1) {
            arrSoloOcupadas.push(reserva)
        }

    }

    return arrSoloOcupadas

}